import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { SurveyImageAnnotation } from '../SurveyImageAnnotation';

interface IAnnotation2dProps extends ITranslateProps {
    reportImage: string;
    reportImageTitle: string;
    objectId: string;
    surveyId?: string | undefined;
}

class Annotation2dComponent extends React.Component<IAnnotation2dProps, Record<string, unknown>> {
    constructor(props: IAnnotation2dProps) {
        super(props);
    }

    public override render() {
        return (
            <div className="panel" id={this.props.reportImage}>
                <div className="panel-heading">
                    <span className="panel-icon">
                        <i className="fa fa-tag" />
                    </span>
                    <span className="panel-title">{this.props.reportImageTitle}</span>

                    <div className="pull-right">
                        <a
                            href={`/annotation.html?assetid=${this.props.reportImage}&objectid=${this.props.objectId}&surveyid=${this.props.surveyId}`}
                            target="_blank"
                            className="btn btn-default btn-sm mb10 fw600 ml10"
                            rel="noreferrer"
                        >
                            <span className="fa fa-external-link pr5" /> {this.props.t('survey.open2dViewer')}
                        </a>
                    </div>
                </div>

                <div className="panel-body p10">
                    <SurveyImageAnnotation
                        objectId={this.props.objectId}
                        assetId={this.props.reportImage}
                        surveyId={this.props.surveyId}
                        smallFont={true}
                    />
                </div>
            </div>
        );
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Annotation2D = translate()(Annotation2dComponent);
